// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1600":"d49f61db","3672":"29b380e8"}[chunkId] + ".chunk.css";
};